<template>
  <WsMain>
    <WsCRUD
      :modelName="modelName"
      :label="label"
      :fields="fields"
      :liveSearching="true"
      :sortBy="sortBy"
      :showFields="showFields"
      :pageMode="true"
      :showExpand="false"
      :inRowBtnRead="true"
      :rowClickRead="true"
      :filterSelects="filterSelects"
      :isMultiSelect="true"
    ></WsCRUD>
  </WsMain>
</template>
<script>
import model from '@/models/role';

export default {
  data() {
    return {
      modelName: model.modelName,
      label: model.label,
      fields: model.fields,
      showFields: ['id', 'sequence', 'name', 'is_default', 'factories', 'updated_at'],
      liveSearching: true,
      sortBy: 'sequence',
      filterSelects: [
        {
          type: 'hasMany',
          label: '',
          textKey: 'name',
          modelName: 'factory',
          paramName: 'factories',
          placeholder: '篩選適用工廠',
        },
        {
          type: 'switch-tabs',
          label: '',
          textKey: 'name',
          modelName: 'is_active',
          defaultValue: '1',
          items: [
            {
              value: '1',
              text: '啟用',
            },
            {
              value: '0',
              text: '停用',
            },
          ],
        },
      ],
    };
  },
};
</script>
